import { Typography } from '@p2p/components';
import { Timer, useTimer } from '@p2p/entities/payment';
import cn from 'classnames';

import styles from './PaymentTimer.module.scss';
import { PaymentTimerProps } from './PaymentTimer.types';

export const PaymentTimer = ({ time, className }: PaymentTimerProps) => {
  const { second } = useTimer({ time });

  return (
    <div className={cn(styles.timerContainer, className)}>
      <Typography variant="text-m-bold" color="heading">
        До окончания осталось
      </Typography>
      <Timer time={second} />
    </div>
  );
};
